<template>
	<div class="rich-text-editor">
		<el-input
			:value="value"
			type="textarea"
			:rows="rows"
			:placeholder="placeholder"
			:disabled="disabled"
			@input="$emit('input', $event)" />
		<p class="rich-text-editor__hint">支持 HTML 富文本；前台详情页将原样渲染。</p>
	</div>
</template>

<script>
export default {
	name: 'RichTextEditor',
	props: {
		value: { type: String, default: '' },
		placeholder: { type: String, default: '请输入商品详情（支持 HTML）' },
		disabled: { type: Boolean, default: false },
		rows: { type: Number, default: 14 },
		height: { type: String, default: '360px' },
	},
};
</script>

<style scoped>
.rich-text-editor__hint {
	margin: 6px 0 0;
	font-size: 12px;
	color: #909399;
}
</style>
